export const ADDON_HEADERS = [
  {
    text: 'upsell.table.position',
    value: 'position',
  },
  {
    text: 'upsell.table.article',
    value: 'article',
    type: 'slot',
  },
  {
    text: 'upsell.table.plu',
    value: 'plu',
    type: 'slot',
    virtual: true,
  },
];

export const GOAL_HEADERS = [
  {
    text: 'upsell.table.mov',
    value: 'mov',
    type: 'decimal',
  },
  {
    text: 'upsell.table.roundTo',
    value: 'roundTo',
    type: 'decimal',
  },
  {
    text: 'upsell.table.articles',
    value: 'articles',
    type: 'slot',
  },
];

export const UPGRADE_HEADERS = [
  {
    text: 'upsell.table.upgradeFrom',
    value: 'upgradeFrom',
    type: 'slot',
  },
  {
    text: 'upsell.table.upgradeTo',
    value: 'upgradeTo',
    type: 'slot',
  },
];
